/**
 * '코드 단순하게' (초보용, 2026-10): 어려운 코드를 기본 3화음으로 바꿔 보여 준다.
 * Cmaj7·C6·Cadd9·Csus4 → C, Cm7·Cm9 → Cm, C7 → C, D/F# → D, Bm7b5 → Bm, Cdim 은 그대로.
 * 표시용 HTML("C<sup>#</sup>m7", "Bᵇmaj7") 과 악보 원문("C#m7", "Bbmaj7") 모두 받는다.
 */
export const simplifyChord = (html: string): string => {
  if (!html) return html;
  const m = html.match(/^([A-G](?:<sup>#<\/sup>|ᵇ|♭|#|b)?)(.*)$/);
  if (!m) return html;
  const root = m[1];
  let rest = m[2].replace(/\/.*$/, ""); // 베이스음(분수 코드) 빼기
  rest = rest.replace(/<[^>]+>/g, "");
  if (/^(dim|o|°)/.test(rest)) return root + "dim";
  // m 다음에 aj 가 오면 maj(장조) — 'mM7'·'m(maj7)' 은 단조
  const minor = /^m(?!aj)/.test(rest) || /^-/.test(rest);
  return root + (minor ? "m" : "");
};
